import { Reducer } from 'redux';
import { produce } from 'immer';

import { COUNTER_TYPES, CounterState } from './types';

export const INITIAL_STATE: CounterState = {
  value: 0,
};

const reducer: Reducer<CounterState> = (
  state = INITIAL_STATE,
  action = { type: '', payload: {} },
) => {
  return produce(state, draft => {
    switch (action.type) {
      case COUNTER_TYPES.INCREMENT_SUCCESS:
        draft.value = 2;
        break;
      case COUNTER_TYPES.DECREMENT_SUCCESS:
        draft.value = 0;
        break;
      default:
    }
  });
};

export default reducer;
